import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Badge, Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import ActivityLog from '../ActivityLog';
import * as Common from "../Common";
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from "../Picklist";

function Tran_vtm_activation() {
    const sid = sessionStorage.getItem("sessionId");
    const navigate = useNavigate();
    const finStartDate = sessionStorage.getItem("startDate");
    const finEndDate = sessionStorage.getItem("endDate");
    const branchDisable = sessionStorage.getItem('branchDisable');


    const [userRight, setUserRight] = useState([]);
    const [approvalRight, setApprovalRight] = useState([]);
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [scrMode, setScrMode] = useState("");

    const [acSrno, setAcSrno] = useState("");
    const [acLocation, setAcLocation] = useState(null);
    const [acLocationValue, setAcLocationValue] = useState("0");
    const [acIssuer, setAcIssuer] = useState(null);
    const [acCardNo, setAcCardNo] = useState("");
    const [acCorporate, setAcCorporate] = useState(null);
    const [acDate, setAcDate] = useState(null);
    const [acReferenceNo, setAcReferenceNo] = useState("");
    const [acPurchaseNo, setAcPurchaseNo] = useState("");
    const [acInvoiceRemark, setAcInvoiceRemark] = useState("");
    const [acPassport, setAcPassport] = useState("");
    const [acCardValue, setAcCardValue] = useState("");
    const [acStatus, setAcStatus] = useState('PENDING');
    const [filterStatus, setFilterStatus] = useState('PENDING');

    const [vtmData, setVtmData] = useState([]);
    const [acIndividual, setAcIndividual] = useState(null);

    const [acIsd, setAcIsd] = useState(null);
    const [hdrSrno, setHdrSrno] = useState(0);
    const [hdrLocation, setHdrLocation] = useState("");
    const [acIndividualId, setAcIndividualId] = useState("");
    const [filterFromDate, setFilterFromDate] = useState(new Date());
    const [filterToDate, setFilterToDate] = useState(new Date());
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", location: "" });
    const [aclocationType, setAclocationType] = useState("O");
    const [filterSearch, setFilterSearch] = useState("");
    const [acValue, setAcValue] = useState("");
    const [acRate, setAcRate] = useState("");
    const [acAmount, setAcAmount] = useState("");
    const [acIssuePlace, setAcIssuePlace] = useState("");
    const [acPanNo, setAcPanNo] = useState("");
    const [acNationality, setAcNationality] = useState("");
    const [acCity, setAcCity] = useState("");
    const [acPin, setAcPin] = useState("");
    const [acPhone, setAcPhone] = useState("");
    const [acAddress, setAcAddress] = useState("");
    const [acCountry, setAcCountry] = useState("");
    const [acTravelType, setAcTravelType] = useState("");
    const [acBillNo, setAcBillNo] = useState("");
    const [acMobile, setAcMobile] = useState("");
    const [acEmail, setAcEmail] = useState("");
    const [acDob, setAcDob] = useState(new Date());
    const [acExpiryDate, setAcExpiryDate] = useState(new Date());
    const [acApproverRemark, setAcApproverRemark] = useState("");
    const [acActivatedBy, setActivatedBy] = useState("");
    const [aclistLimit, setAclistLimit] = useState("A");
    const [prdLineNo, setPrdLineNo] = useState("");
    const [motherName, setMotherName] = useState("");
    const [vtmReleasedStatus, setVtmReleasedStatus] = useState("0");
    const [activationDateDMY, setActivationDateDMY] = useState(null);
    const [viewLocationCode, setViewLocationCode] = useState("");
    const [individualName, setIndividualName] = useState("");
    const [filterIssuer, setFilterIssuer] = useState();
    const [acBranchRemark, setAcBranchRemark] = useState("");



    useEffect(() => {
        Common.getActiveBranch().then(response => {
            setAcLocation(response);
            response != null && handleLocationChange(response);
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_VTM_ACTIVATION'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_VTM_ACTIVATION_APPROVER'], function (result) {
            let resp = JSON.parse(result);
            setApprovalRight(resp);
        });

    }, []);

    const listData = () => {
        $(".loader").show();
        const obj = {
            filterStatus: filterStatus,
            acLocationValue: acLocationValue,
            fromDate: Common.dateYMD(filterFromDate),
            toDate: Common.dateYMD(filterToDate),
            aclocationType: aclocationType,
            filterSearch: filterSearch,
            showHeader: false,
            listLimit: aclistLimit,
            filterIssuer: filterIssuer
        }
        Common.callApi(Common.apiVtmActivation, [sid, "listdata", JSON.stringify(obj)], result => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            setVtmData(resp.data);
        });
    }

    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN('Do you really want to exit ?');
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
    }

    const handleLocationChange = (value) => {
        setAcLocation(value);
        var id = value.id;
        var locationArr = id.split("^");
        setAcLocationValue(locationArr[1]);
        setHdrLocation(locationArr[2]);
        console.log(locationArr[2])
        sessionStorage.activeBranch = locationArr[1];
    }

    const fillViewForm = (location, srno, prd_line_no) => {
        setHdrSrno(0);
        setScrMode("Q");
        setAcSrno(srno);
        const obj = {
            location: location,
            srno: srno,
            prdLineNo: prd_line_no
        }
        Common.callApi(Common.apiVtmActivation, [sid, "viewdata", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setViewLocationCode(resp.location)
            setHdrLocation(resp.entity_name)
            setHdrSrno(resp.bill_no)
            setPrdLineNo(resp.prd_line_no);
            console.log("this is ", resp.issuer_label)
            setAcIssuer(resp.issuer_label);
            setAcReferenceNo(resp.reference_no);
            setAcCardNo(resp.card_no);
            setAcIsd(resp.isd);
            setAcCardValue(resp.value_card_amount);
            setAcRate(resp.sale_rate);
            setAcAmount(resp.amount_in_inr);
            setAcIssuePlace(resp.place_of_issue);
            setAcPassport(resp.passport_no);
            if (resp.expiry_date !== null) setAcExpiryDate(new Date(resp.expiry_date))
            else setAcExpiryDate(null);
            if (resp.dob !== null) setAcDob(new Date(resp.dob))
            else setAcDob(null);
            if (resp.activation_date !== null) setAcDate(new Date(resp.activation_date))
            else setAcDate(null);
            setAcApproverRemark(resp.approver_remark);
            setAcIndividual(resp.ind_label);
            setAcPanNo(resp.pan_no);
            setAcNationality(resp.nationality);
            setAcCity(resp.city);
            setAcPhone(resp.phone);
            setAcPin(resp.pin);
            setAcAddress(resp.address);
            setAcCountry(resp.travel_country);
            setAcTravelType(resp.purpose_name);
            setAcBillNo(resp.bill_no);
            setAcMobile(resp.mobile);
            setAcEmail(resp.email);
            if (resp.corp_label !== '0 0 ') setAcCorporate(resp.corp_label)
            else setAcCorporate(null);
            setAcInvoiceRemark(resp.remark);
            setAcStatus(resp.prd_vtm_status);
            setActivatedBy(resp.activated_by);
            setMotherName(resp.mother_name);
            setVtmReleasedStatus(resp.prd_vtm_released_status);
            setActivationDateDMY(resp.prd_activation_dmy);
            setIndividualName(resp.individual_name);
            if (resp.prd_vtm_status === "PENDING") setAcBranchRemark("");
            else setAcBranchRemark(resp.prd_branch_remark);
        });
    }

    // const editData = () => {
    //     setScrMode("E");
    // }

    const saveData = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (acIsd === null || acIssuer === null || acCardNo === "" || acReferenceNo === "" || acCardValue === "" || acIndividual === null) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (acIsd === null ? "Isd" : "");
            msg[i++] = (acIssuer === null ? "Issuer" : "");
            msg[i++] = (acCardNo === "" ? "Card Number" : "");
            msg[i++] = (acReferenceNo === "" ? "Reference Number" : "");
            msg[i++] = (acCardValue === "" ? "Request Value" : "");
            msg[i++] = (acIndividual === null ? "Individual Profile" : "");
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                srno: acSrno,
                acIsd: acIsd,
                acIssuer: acIssuer,
                acCardNo: acCardNo,
                acReferenceNo: acReferenceNo,
                acCardValue: acCardValue,
                acIndividual: acIndividual,
                acPassport: acPassport,
                acCorporate: acCorporate,
                acPurchaseNo: acPurchaseNo,
                acDate: Common.dateYMD(acDate),
                acValue: acValue,
                acRemark: acInvoiceRemark,
                acLocationValue: acLocationValue,
                status: acStatus,
                scrMode: scrMode,
                individualId: acIndividualId,
                trantype: "TSA",
                filterStatus: filterStatus,
                fromDate: Common.dateYMD(filterFromDate),
                toDate: Common.dateYMD(filterToDate),
                aclocationType: aclocationType,
                filterSearch: filterSearch
            }
            const obj2 = {
                TabType: "EDIT",
                ALineNo: tranAuditTrail.length + 1,
                AType: "A",
                TLoc: acLocationValue,
                acIsd: acIsd,
                Issuer: acIssuer,
                CardNo: acCardNo,
                ReferenceNo: acReferenceNo,
                RequestedValue: acCardValue,
                Individual: acIndividual,
                Passport: acPassport,
                Corporate: acCorporate,
                PurchaseNo: acPurchaseNo,
                Value: acValue,
                Remark: acInvoiceRemark,
                LocationValue: acLocationValue,
                status: acStatus,
                individualId: acIndividualId,
                TType: 'PPE',

            }
            if (userRight.edit === "1" && scrMode === 'E') {
                var editDataAudit = [obj2];
            }
            Common.callApi(Common.apiVtmActivation, [sid, "savedata", JSON.stringify(obj), JSON.stringify(editDataAudit)], result => {
                let resp = JSON.parse(result);
                if (resp.msg === "MSG0000") {
                    $(".loader").hide();
                    setScrMode("");
                    setVtmData(resp.data);
                } else {
                    $(".loader").hide();
                    setMsgText(Common.getMessage("ERR0000"));
                    setMsgBox(true);
                }
            });
        }
    }

    const exportStatus = () => {
        if (acStatus === "PENDING" && acBranchRemark == "") {
            setMsgText("Please fill Branch Remark.");
            setMsgBox(true);
        } else {
            $(".loader").show();
            const obj = { acSrno: acSrno, acLocationValue: viewLocationCode, prdLineNo: prdLineNo, acBranchRemark: acBranchRemark };
            Common.callApi(Common.apiVtmActivation, [sid, "exportstatus", "EXPORTED", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                if (resp.msg === "MSG0000") {
                    $(".loader").hide();
                    setScrMode("");
                    listData();
                    setAcBranchRemark("");
                }
            });
        }
    }

    const activateStatus = () => {
        $(".loader").show();
        var msg = [], i = 0;
        var d = "";
        var today = "";
        if (acDate !== null) {
            d = Common.dateYMD(acDate);
            today = Common.dateYMD(new Date());
        } if (acApproverRemark == "") {
            $(".loader").hide();
            msg[i++] = (acDate == null ? "Activation Date" : "");
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
        if (acDate == null) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (acDate == null ? "Activation Date" : "");
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (d < today) {
            $(".loader").hide();
            setMsgBox(true);
            setMsgText("Activation date cannot be past date.");
        } else if (d > finEndDate || d < finStartDate) {
            $(".loader").hide();
            setMsgBox(true);
            setMsgText("Activation" + Common.getMessage("MSG0010"));
        } else {
            const obj = {
                acDate: Common.dateYMD(acDate),
                acValue: acValue,
                acSrno: acSrno,
                acLocationValue: viewLocationCode,
                acApproverRemark: acApproverRemark,
                prdLineNo: prdLineNo,
            }
            Common.callApi(Common.apiVtmActivation, [sid, "activatestatus", "ACTIVATED", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                if (resp.msg === "MSG0000") {
                    $(".loader").hide();
                    setScrMode("");
                    listData();
                }
            });
        }
    }

    const rejectStatus = () => {
        $(".loader").show();
        const obj = {
            acSrno: acSrno,
            acLocationValue: viewLocationCode,
            prdLineNo: prdLineNo
        }
        Common.callApi(Common.apiVtmActivation, [sid, "rejectstatus", "REJECTED", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            if (resp.msg === "MSG0000") {
                $(".loader").hide();
                setScrMode("");
                listData();
            }
        });
    }

    const pendingStatus = () => {
        $(".loader").show();
        const obj = { acSrno: acSrno, acLocationValue: viewLocationCode, prdLineNo: prdLineNo }

        Common.callApi(Common.apiVtmActivation, [sid, "pendingstatus", "PENDING", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            if (resp.msg === "MSG0000") {
                $(".loader").hide();
                setScrMode("");
                listData();
            }
        });
    }

    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "TSA", trannumber: hdrSrno, trancategory: "T", location: viewLocationCode });
    }
    const handleDownloadList = () => {
        $(".loader").show();
        const obj = {
            filterStatus: filterStatus,
            acLocationValue: acLocationValue,
            fromDate: Common.dateYMD(filterFromDate),
            toDate: Common.dateYMD(filterToDate),
            aclocationType: aclocationType,
            filterSearch: filterSearch,
            showHeader: true,
            filterIssuer: filterIssuer
        }
        Common.callDownloadApiPost1(Common.apiVtmActivation, "post", [sid, "downloadlist", JSON.stringify(obj)], result => {
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray([result]));
            setMsgBox(true);
        });
    }

    const handleIssuerChange = value => {
        setFilterIssuer(value);
    }
    const clearFilter = () => {
        setAclocationType('O');
        setFilterStatus('PENDING');
        setFilterSearch('');
        setFilterFromDate(new Date());
        setFilterToDate(new Date());
        setFilterIssuer('');
        setAclistLimit('A')
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>VTM Activation</h3>
                    </Col>
                </Row>
                {
                    scrMode === "" ?
                        <>
                            <Row>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Location Type <span className="text-danger">*</span></Form.Label>
                                            <Form.Select value={aclocationType} onChange={e => setAclocationType(e.target.value)}
                                                required>
                                                <option value="A">All</option>
                                                <option value="O">One</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    {aclocationType === 'O' ? <>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={acLocation}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={Picklist.fetchLocationAllowedPicklist}
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleLocationChange}
                                                    isDisabled={branchDisable === "true"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                    </> : null}
                                </Row>
                                <Row>
                                    {filterSearch === "" ?
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Status</Form.Label>
                                                <Form.Select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
                                                    <option value="PENDING">Pending</option>
                                                    <option value="EXPORTED">Exported</option>
                                                    <option value="ACTIVATED">Activated</option>
                                                    <option value="REJECTED">Rejected</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        : null}
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Issuer<span className="text-danger">*</span></Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                defaultOptions
                                                value={filterIssuer}
                                                getOptionLabel={e => e.label + ' '}
                                                getOptionValue={e => e.id}
                                                loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'ISSUER', acLocationValue)}
                                                onInputChange={Picklist.handleInputChange}
                                                onChange={handleIssuerChange}
                                            >
                                            </AsyncSelect>
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Search Box</Form.Label>
                                            <Form.Control placeholder='Search Box' type='text' maxLength={16} value={filterSearch} onChange={e => Common.validateNumValue(e.target.value, setFilterSearch)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-2 col-2'>
                                        <Form.Group>
                                            <Form.Label>Limit<span className="text-danger">*</span></Form.Label>
                                            <Form.Select
                                                value={aclistLimit}
                                                onChange={e => setAclistLimit(e.target.value)}
                                                required
                                            >
                                                <option value="A">All</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    {
                                        filterStatus === 'PENDING' ? <>
                                        </> : <>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                                    <DatePicker className="form-control"
                                                        selected={filterFromDate}
                                                        onChange={(date) => setFilterFromDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        customInput={
                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>To Date<span className="colorThemeRed">*</span></Form.Label><br />
                                                    <DatePicker className="form-control"
                                                        selected={filterToDate}
                                                        onChange={(date) => setFilterToDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        customInput={
                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </>
                                    }
                                </Row>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    {
                                        userRight.query === "1" ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => listData()}>List</Button>
                                            : null
                                    }

                                    &nbsp;
                                    {/* {
                                                    userRight.add === "1" ?
                                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNew()}>Add New</Button>
                                                        : null
                                                } */}

                                    {
                                        userRight.query === "1" ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={clearFilter}>Clear Filter</Button>
                                            : null
                                    }
                                </Col>
                            </Row>
                            <Row className="d-flex align-items-center">
                                <Col className="d-flex align-items-center justify-content-start mt-4">
                                    {userRight.query === "1" && (
                                        <Button variant="outline-primary" className="buttonStyle" size="sm" onClick={handleDownloadList}>
                                            Download
                                        </Button>
                                    )}
                                </Col>
                            </Row>


                            <Row>&nbsp;</Row>
                            {
                                <Row>
                                    <Col>
                                        Count {vtmData?.length || 0}
                                    </Col>
                                </Row>
                            }
                            <Row>
                                <Col>
                                    <Table responsive striped bordered>
                                        <thead>
                                            <tr>
                                                <th>&nbsp;</th>
                                                <th>Sr No </th>
                                                <th>Location</th>
                                                <th>Timestamp</th>
                                                <th>ISD</th>
                                                <th>Issuer</th>
                                                <th>Card No</th>
                                                <th>Corporate</th>
                                                <th>Value</th>
                                                {/* <th>Encashed Value</th> */}
                                                {/* <th>Status</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                vtmData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <span className='colorThemeBlue pointer' onClick={() => fillViewForm(item.prd_location, item.prd_srno, item.prd_line_no)}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>
                                                        </td>
                                                        <td>{item.prd_srno}</td>
                                                        <td>{item.entity_name}</td>
                                                        <td>{(filterStatus == 'ACTIVATED') ? item.prd_vtm_activation_datetime : (filterStatus == 'EXPORTED') ? item.prd_vtm_export_datetime : (filterStatus == 'PENDING' ? item.hdr_timestamp_datetime : (filterStatus == 'REJECTED' ? item.prd_vtm_reject_datetime : null))}</td>
                                                        <td>{item.prd_isd}</td>
                                                        <td>{item.issuer_name}</td>
                                                        <td>{item.prd_card_no}</td>
                                                        <td>{item.corp_name}</td>
                                                        <td>{item.value}</td>
                                                        {/* <td>{item.tve_requested_value}</td>
                                                                    <td>{item.tve_encashed_value}</td>
                                                                    <td>{item.tve_status}</td> */}
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </>
                        :
                        <>
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                    &nbsp;
                                    {
                                        ((userRight.edit === "1" || userRight.query === "1") && scrMode === 'Q') ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                btnActivityLog()}>Activity Log</Button>&nbsp;
                                        </> : null
                                    }
                                    &nbsp;
                                </Col>

                            </Row>
                            <Row>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Serial Number : {hdrSrno}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <span>Location : <b>{hdrLocation} </b></span>
                                    </Col>
                                    {acStatus === 'ACTIVATED' ?
                                        <Col className="col-md-2 col-4">
                                            <span>Activated By : <b>{acActivatedBy} </b></span>
                                        </Col> : null}
                                </Row>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Status<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Select disabled value={acStatus} onChange={e => setAcStatus(e.target.value)}>
                                                <option value="PENDING">Pending</option>
                                                <option value="EXPORTED">Exported</option>
                                                <option value="ACTIVATED">Activated</option>
                                                <option value="REJECTED">Rejected</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    {/* <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Issuer<span className="colorThemeRed">*</span></Form.Label>
                                            <AsyncSelect
                                                cacheOptions={false}
                                                defaultOptions={false}
                                                value={acIssuer}
                                                getOptionLabel={e => e.label + ' '}
                                                getOptionValue={e => e.id}
                                                loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'ISSUER', acLocationValue)} // location = 1 , 2
                                                onInputChange={Picklist.handleInputChange}
                                                onChange={value => setAcIssuer(value)}
                                                isDisabled={scrMode === "Q"}
                                            >
                                            </AsyncSelect>
                                        </Form.Group>
                                    </Col> */}
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Issuer<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Issuer' type='text' value={acIssuer} onChange={e => Common.validateNumValue(e.target.value, setAcIssuer)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Reference No<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Reference No' type='text' maxLength={16} value={acReferenceNo} onChange={e => Common.validateNumValue(e.target.value, setAcReferenceNo)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Card No<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Card No' type='text' maxLength={20} value={acCardNo} onChange={e => Common.validateAlpNumValue(e.target.value, setAcCardNo)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>

                                    {/* <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>ISD<span className="colorThemeRed">*</span></Form.Label>
                                            <AsyncSelect
                                                cacheOptions={false}
                                                defaultOptions={false}
                                                value={acIsd}
                                                getOptionLabel={e => e.label + ' '}
                                                getOptionValue={e => e.id}
                                                loadOptions={(search) => Picklist.fetchCurrencyAllowedPicklist(search, "")}
                                                onInputChange={Picklist.handleInputChange}
                                                onChange={value => setAcIsd(value)}
                                                isDisabled={scrMode === "Q"}
                                            >
                                            </AsyncSelect>
                                        </Form.Group>
                                    </Col>
                                     */}
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>ISD<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='ISD' type='text' value={acIsd} onChange={e => Common.validateAlpNumValue(e.target.value, setAcIsd)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Card Value<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Requested Value' type='text' maxLength={10} value={acCardValue} onChange={e => Common.validateDecValue(e.target.value, setAcCardValue)} />
                                        </Form.Group>
                                    </Col>

                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Sale Rate<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Sale Rate' type='text' value={acRate} onChange={e => Common.validateNumValue(e.target.value, setAcRate)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Amount in INR<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Amount' type='text' value={acAmount} onChange={e => Common.validateNumValue(e.target.value, setAcAmount)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>

                                </Row>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Individual Name</Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Individual Name' type='text' value={individualName} onChange={e => Common.validateAlpNumValue(e.target.value, setIndividualName)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Place Of Issue</Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Issue Place' type='text' value={acIssuePlace} onChange={e => Common.validateAlpValue(e.target.value, setAcIssuePlace)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Passport No</Form.Label>
                                            <Form.Control disabled={scrMode === "Q" || acPassport !== ""} placeholder='Passport No' type='text' maxLength={20} value={acPassport} onChange={e => Common.validateAlpNumValue(e.target.value, setAcPassport)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Expiry Date</Form.Label>
                                            <DatePicker className="form-control"
                                                selected={acExpiryDate}
                                                onChange={(date) => setAcExpiryDate(date)}
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                disabled={scrMode === "Q"}
                                                customInput={
                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Individual Profile<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Individual Profile' type='text' value={acIndividual} onChange={e => Common.validateAlpNumValue(e.target.value, setAcIndividual)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>

                                    {/* <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Individual Profile<span className="colorThemeRed">*</span>
                                                {
                                                    scrMode === "Q" ? null :
                                                        <>
                                                            <span className='tranNewFormText' onClick={() => newIndividual("A")}>Not in list? Create New</span>
                                                            &nbsp;&nbsp;
                                                            <span className='tranNewFormText' onClick={() => newIndividual("E")}>Edit</span>
                                                        </>
                                                }
                                            </Form.Label>
                                            <AsyncSelect
                                                value={acIndividual}
                                                cacheOptions={false}
                                                defaultOptions={false}
                                                getOptionLabel={e => e.label + ' '}
                                                getOptionValue={e => e.id}
                                                loadOptions={(search) => Picklist.fetchIndividualPicklist(search, "SALE")}
                                                onInputChange={Picklist.handleInputChange}
                                                formatOptionLabel={Picklist.formatOptionLabel}
                                                components={{ Menu: Picklist.menu }}
                                                onChange={handleIndiviualSearchChange}
                                                isDisabled={scrMode === "Q"}
                                            >
                                            </AsyncSelect>
                                        </Form.Group>
                                    </Col>
                                     */}
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Date Of Birth</Form.Label>
                                            <DatePicker className="form-control"
                                                selected={acDob}
                                                onChange={(date) => setAcDob(date)}
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                disabled={scrMode === 'Q'}
                                                customInput={
                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>PAN No</Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='PAN No' type='text' maxLength={10} value={acPanNo} onChange={e => Common.validatePan(e.target.value, setAcPanNo)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Mother Name</Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Mother Name' type='text' value={motherName} onChange={e => Common.validatePan(e.target.value, setMotherName)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Nationality</Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Nationality' type='text' value={acNationality} onChange={e => Common.validateAlpNumValue(e.target.value, setAcNationality)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>

                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>City</Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='City' type='text' value={acCity} onChange={e => Common.validateAlpNumValue(e.target.value, setAcCity)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Phone</Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Phone' type='text' value={acPhone} onChange={e => Common.validateAlpNumValue(e.target.value, setAcPhone)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Pin</Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Pin' type='text' value={acPin} onChange={e => Common.validateAlpNumValue(e.target.value, setAcPin)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Residential Address</Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Residential Address' type='text' value={acAddress} onChange={e => Common.validateAlpNumValue(e.target.value, setAcAddress)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>

                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Country Of Travel</Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Country to travel' type='text' value={acCountry} onChange={e => Common.validateAlpNumValue(e.target.value, setAcCountry)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Type Of Travel</Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Residential Address' type='text' value={acTravelType} onChange={e => Common.validateAlpNumValue(e.target.value, setAcTravelType)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Sale Bill Number</Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Sale Bill No' type='text' value={acBillNo} onChange={e => Common.validateAlpNumValue(e.target.value, setAcBillNo)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Mobile</Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Mobile' type='text' value={acMobile} onChange={e => Common.validateAlpNumValue(e.target.value, setAcMobile)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Email' type='text' value={acEmail} onChange={e => Common.validateAlpNumValue(e.target.value, setAcEmail)} />
                                        </Form.Group>
                                    </Col>
                                    {/* <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Corporate</Form.Label>
                                            <AsyncSelect
                                                cacheOptions={false}
                                                defaultOptions={false}
                                                value={acCorporate}
                                                getOptionLabel={e => e.label + ' '}
                                                getOptionValue={e => e.id}
                                                loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'CORPORATE', acLocationValue)} // location = 1 , 2
                                                onInputChange={Picklist.handleInputChange}
                                                onChange={value => setAcCorporate(value)}
                                                isDisabled={scrMode === "Q"}
                                            >
                                            </AsyncSelect>
                                        </Form.Group>
                                    </Col> */}
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Corporate</Form.Label>
                                            <Form.Control disabled={scrMode === "Q"} placeholder='Corporate' type='text' value={acCorporate} onChange={e => Common.validateAlpValue(e.target.value, setAcCorporate)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='col-md-12'>
                                        <Form.Group>
                                            <Form.Label>Invoice Remarks</Form.Label>
                                            <Form.Control disabled={scrMode === "Q" || approvalRight.query === "1"} placeholder='Remark' type='text' maxLength={50} value={acInvoiceRemark} onChange={e => Common.validateAlpValue(e.target.value, setAcInvoiceRemark)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                {/* {
                                    acStatus === "PENDING" &&
                                    <> */}
                                <Row>
                                    <Col className='col-md-12'>
                                        <Form.Group>
                                            <Form.Label>Branch Remarks<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control
                                                disabled={acStatus === "ACTIVATED" || acStatus === "REJECTED" || acStatus === "EXPORTED"}
                                                placeholder='Branch Remark'
                                                type='text'
                                                maxLength={50}
                                                value={acBranchRemark}
                                                onChange={e => Common.validateAlpValue(e.target.value, setAcBranchRemark)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                {/* </>
                                } */}
                                {approvalRight.query === "1" ?
                                    <>
                                        <Row>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Activation Date</Form.Label>
                                                    <DatePicker className="form-control"
                                                        selected={acDate}
                                                        onChange={(date) => setAcDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        disabled={acStatus === "ACTIVATED" || acStatus === "REJECTED" || acStatus === "PENDING" || !(approvalRight.query === "1")}
                                                        customInput={
                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className='col-md-12'>
                                                <Form.Group>
                                                    <Form.Label>Approver Remark</Form.Label>
                                                    <Form.Control disabled={acStatus === "ACTIVATED" || acStatus === "REJECTED" || acStatus === "PENDING" || !(approvalRight.query === "1")} placeholder='Remark' type='text' maxLength={50} value={acApproverRemark} onChange={e => Common.validateAlpNumValue(e.target.value, setAcApproverRemark)} />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </>
                                    : null
                                }
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>

                                    {/* {
                                        userRight.edit === "1" && scrMode === 'Q' && acStatus === "PENDING" ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                editData()}>Edit</Button>&nbsp;
                                        </> : null
                                    } */}

                                    {/* {
                                        (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>
                                            &nbsp;
                                        </> : null
                                    } */}

                                    {
                                        acStatus === "PENDING" && userRight.add === "1" && (scrMode === "Q" || scrMode === "E") ? <>
                                            <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => exportStatus()}>Export</Button>
                                            &nbsp;
                                        </>
                                            : null
                                    }
                                    &nbsp;

                                    {/* {
                                        (userRight.add === "1" && acStatus === "PENDING" && scrMode === "Q") &&
                                        <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => rejectStatus()}>Reject</Button>
                                    } */}
                                    {
                                        approvalRight.query === "1" && acStatus === "EXPORTED" ?
                                            <>
                                                {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}> */}
                                                <span style={{ fontSize: "15px", display: scrMode === "A" ? "none" : "block" }}>
                                                    {vtmReleasedStatus === "0" ? null : (<Badge bg="success">Activated Previously<span> Activated on: {activationDateDMY}, Activated By: {acActivatedBy}</span></Badge>)}</span>
                                                <Button variant='outline-success' size='sm' className='buttonStyle' onClick={() => activateStatus()}>Activate</Button>
                                                {/* </div> */}
                                                &nbsp;
                                                <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => rejectStatus()}>Reject</Button>
                                                &nbsp;
                                                <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => pendingStatus()}>Send Back to Branch</Button>
                                            </>
                                            : null
                                    }
                                    {
                                        approvalRight.query === "1" && acStatus === "ACTIVATED" ?
                                            <>
                                                <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => pendingStatus()}>Release</Button>
                                            </>
                                            : null
                                    }
                                </Col>
                            </Row>
                        </>
                }
            </Container>

            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>
        </>
    )
}

export default Tran_vtm_activation
